import React from "react";
import Label from "../label";
import MessageError from "../../message/__errors";
import "../styles.css";

// Поле даты без времени. value — строка YYYY-MM-DD (так её отдаёт нативный input type="date");
// readOnly — «23.10.2026». Строкой, а не Date: иначе дата «съезжала» бы на день по часовому поясу.
export default function InputDate({ value = '', children, errors, className = '', hasLabel = true, readOnly = false, ...other }) {
    return <>
        {hasLabel ? <Label>{children}</Label> : null}
        {readOnly
            ? <input
                type="text"
                readOnly={true}
                value={value ? value.split('-').reverse().join('.') : ''}
                className={`input ${className}`}
            />
            : <input
                {...other}
                type="date"
                value={value ?? ''}
                className={`input ${className}`}
            />}
        {errors ? <MessageError errors={errors}/> : null}
    </>;
}
